import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpResponse, HttpClient } from '@angular/common/http';
import { CommonService } from 'src/app/_services/common.service';
import { ModalService } from 'src/app/_services/modal.service';
import { API_URL } from 'src/app/_common/constants';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NewBusinessService {

  private _loading:boolean = false;
  private _selectedBusiness: string = "";

  constructor(private http: HttpClient, private commonService: CommonService, private modalService: ModalService) { }

  set header(data){
    this.commonService.header = data;
  }
  set loading(_loading){
    this._loading = _loading;
  }

  get loading():boolean{
    return this._loading;
  }
  get runningServices(){
    return this.commonService.runningServices;
  }

  get selectedBusiness():string{
    return this._selectedBusiness;
  }

  set selectedBusiness(_selectedBusiness){
    this._selectedBusiness = _selectedBusiness;
  }
  
  openModal(modalType, modalName, isKeyboard = true, backdropClass: string = '', isBackdrop?: boolean | 'static', customWindowClass='', size ="", _centered=true) {
    if(modalType === 'error'){
      this.modalService.openErrorModal();
    } else {
      this.modalService.openModal(modalName, isKeyboard, backdropClass, isBackdrop, customWindowClass, size, _centered);
    }
  }

  closeModal() {
    this.modalService.closeModal();
  }

  hasOpenModals() {
    return this.modalService.hasOpenModals();
  }

  
  //Fetch Niches & Producer Codes
  fetchNiches(){
    return this.http.get<any>(API_URL.ProducersByNiches, {observe: 'response'})
        .pipe(map(response => {
            return response.body.result;
        }));
  }

  //Validate Address
  validateAddress(address): Observable<HttpResponse<any>>{
    this._loading = true;
    return this.http.post<any>(API_URL.VerifyAddress, address, {observe: 'response'})
        .pipe(map(response => {
          this._loading = false;
          return response.body.result;
    }));
  }

  //ClearAccount
  clearAccount(accountData): Observable<HttpResponse<any>>{
    this._loading = true;
    return this.http.post<any>(API_URL.ClearAccount, accountData, {observe: 'response'})
        .pipe(map(response => {
          this._loading = false;
          console.log('Account Cleared for Submission!!!');
          return response.body.result;
        }));
  }
  
  //Upload Additional Documents
  uploadDocuments(_documents): Observable<HttpResponse<any>>{
    this._loading = true;
    return this.http.post<any>(API_URL.DocumentsUpload, _documents, {observe: 'response'})
        .pipe(map(response => {
          this._loading = false;
          console.log('Account Cleared for Submission!!!');
          return response.body.result;
        }));
  }

}
